import deviceSettingsSlice from '.';

export const { setDeviceVariant, unsetEndedExperiments, setGuestSessionLockUntil } = deviceSettingsSlice.actions;
